import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogUrl?: string;
  url?: string; // alias for canonical/ogUrl
  keywords?: string;
}

export const SEO = ({ 
  title, 
  description, 
  canonical,
  ogImage = "https://www.leafrushmarketing.com/og-image.jpg",
  ogUrl,
  url,
  keywords = "lawn care websites, landscaping websites, lawn care marketing, landscaping marketing"
}: SEOProps) => {
  const fullTitle = title.includes("| Leaf Rush") ? title : `${title} | Leaf Rush Marketing`;
  const resolvedCanonical = canonical || url;
  // Safety guard: og:url defaults to canonical when not provided
  const resolvedOgUrl = ogUrl || url || canonical;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      {resolvedCanonical && <link rel="canonical" href={resolvedCanonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {resolvedOgUrl && <meta property="og:url" content={resolvedOgUrl} />}
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@LeafRushMarketing" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
